import React from 'react';

const SpotlightTabsImage: React.FC<{
  src?: string;
  alt?: string;
}> = ({ src, alt }) => {
  return (
    <div
      key={src}
      className={`animate-reveal-down w-[90vw] max-w-xl lg:w-full lg:max-w-lg lg:px-8 sm:gap-4 sm:px-4`}
    >
      {src && (
        <img
          src={src}
          alt={alt}
          className={`solid aspect-video w-full border-rounded-strong`}
        />
      )}
    </div>
  );
};

export default SpotlightTabsImage;
